<template>
  <footer class="footer">
    <p>Copyright © 2024 NARO / RFJ CO., Ltd. All rights reserved.</p>
  </footer>
</template>

<style scoped>
.footer {
  width: 100%;
  color: white;
  background-color: #333;
  text-align: center;
  bottom: 0;
  left: 0;
  box-shadow: 0 -1px 5px rgba(0,0,0,0.1);
}
</style>
